// Models
import { ContainerType } from "../service/graph-legacy/container/ContainerType";
/**
 * Helper function to check whether the container type of a plan is shared
 * @param containerType The container type of the plan to check
 */ export const isSharedContainer = (containerType)=>{
    return containerType === ContainerType.Group || containerType === ContainerType.Roster;
};
